var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDaughter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 26",
    style: {
      enableBackground: "new 0 0 15 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#042b62;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.9,5.6h1.6c0.2,0,0.4-0.2,0.4-0.4c0.1-0.8,0.3-1.7,0.8-2.4c0,0,0,0.1,0,0.1c0,1.6,1.3,2.9,2.9,2.9 s2.9-1.3,2.9-2.9c0-0.1,0-0.1,0-0.2c0.5,0.7,0.8,1.6,0.9,2.5c0,0.2,0.2,0.4,0.4,0.4h1.6c0.1,0,0.2-0.1,0.3-0.1 c0.1-0.1,0.1-0.2,0.1-0.3c-0.2-1.8-1.7-3.3-3.5-3.4C9.8,0.7,8.8,0,7.6,0C6.4,0,5.4,0.7,4.9,1.7C3.1,1.9,1.7,3.3,1.5,5.1 c0,0.1,0,0.2,0.1,0.3C1.7,5.6,1.8,5.6,1.9,5.6z M7.5,7c-0.6,0-1.3,0-2,0C5,7,4.5,7.2,4.3,7.6L0.1,16c-0.3,0.6-0.1,1.2,0.5,1.5 c0.2,0.1,0.3,0.1,0.5,0.1c0.4,0,0.8-0.2,1-0.6l1.3-2.7l-0.6,3.8c-0.1,0.5,0,1,0.5,1.3c0.2,0.1,0.4,0.2,0.7,0.2h0.3V24 c0,0.7,0.6,1.4,1.3,1.4C6.4,25.4,7,24.8,7,24v-3.9c0-0.2,0.2-0.4,0.4-0.4C7.6,19.7,7.6,15.5,7.5,7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.4,7c0.6,0,1.3,0,2,0c0.5,0,1,0.1,1.2,0.6l4.2,8.4c0.3,0.6,0.1,1.2-0.5,1.5c-0.2,0.1-0.3,0.1-0.5,0.1 c-0.4,0-0.8-0.2-1-0.6l-1.3-2.7l0.6,3.8c0.1,0.5,0,1-0.5,1.3c-0.2,0.1-0.4,0.2-0.7,0.2h-0.3V24c0,0.7-0.6,1.4-1.3,1.4 c-0.8,0-1.4-0.6-1.4-1.3v-3.9c0-0.2-0.2-0.4-0.4-0.4C7.3,19.7,7.2,15.5,7.4,7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaughter);
export default __webpack_public_path__ + "static/media/daughter.8332b325fef1a1fda9adefab11da16bd.svg";
export { ForwardRef as ReactComponent };